// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
fuse-theme-options {
  display: flex;
  overflow: hidden;
}
fuse-theme-options .theme-options-panel {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 40px 24px 24px 24px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
fuse-theme-options .theme-options-panel .header {
  display: flex;
  flex: 0 1 auto;
  margin-bottom: 32px;
  align-items: center;
  justify-content: space-between;
}
fuse-theme-options .theme-options-panel .header .title {
  font-size: 20px;
  font-weight: 600;
  padding-left: 4px;
}
fuse-theme-options .theme-options-panel form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
fuse-theme-options .theme-options-panel form .group {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  position: relative;
  border-radius: 2px;
  padding: 28px 16px 8px 16px;
  margin: 16px 0;
}
fuse-theme-options .theme-options-panel form .group h2 {
  position: absolute;
  top: -11px;
  left: 8px;
  margin: 0;
  padding: 0 8px;
  font-size: 16px;
  font-weight: 600;
}
fuse-theme-options .theme-options-panel form .group h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 24px 0 16px 0;
  padding: 0;
}
fuse-theme-options .theme-options-panel form .group h3:first-of-type {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/theme-options/theme-options.component.scss"],"names":[],"mappings":"AAAA;EACI;IACI,uBAAA;EACN;EAEE;IACI,yBAAA;EAAN;AACF;AAGA;EACI,aAAA;EACA,gBAAA;AADJ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,4BAAA;EACA,cAAA;EACA,iCAAA;AADR;AAGQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AADZ;AAGY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AADhB;AAKQ;EACI,aAAA;EACA,cAAA;EACA,sBAAA;AAHZ;AAKY;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AAHhB;AAKgB;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHpB;AAMgB;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;AAJpB;AAMoB;EACI,aAAA;AAJxB","sourcesContent":["@keyframes rotating {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\nfuse-theme-options {\n    display: flex;\n    overflow: hidden;\n\n    .theme-options-panel {\n        display: flex;\n        flex-direction: column;\n        flex: 1 0 auto;\n        padding: 40px 24px 24px 24px;\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n\n        .header {\n            display: flex;\n            flex: 0 1 auto;\n            margin-bottom: 32px;\n            align-items: center;\n            justify-content: space-between;\n\n            .title {\n                font-size: 20px;\n                font-weight: 600;\n                padding-left: 4px;\n            }\n        }\n\n        form {\n            display: flex;\n            flex: 1 1 auto;\n            flex-direction: column;\n\n            .group {\n                display: flex;\n                flex: 1 0 auto;\n                flex-direction: column;\n                position: relative;\n                border-radius: 2px;\n                padding: 28px 16px 8px 16px;\n                margin: 16px 0;\n\n                h2 {\n                    position: absolute;\n                    top: -11px;\n                    left: 8px;\n                    margin: 0;\n                    padding: 0 8px;\n                    font-size: 16px;\n                    font-weight: 600;\n                }\n\n                h3 {\n                    font-size: 14px;\n                    font-weight: 600;\n                    margin: 24px 0 16px 0;\n                    padding: 0;\n\n                    &:first-of-type {\n                        margin-top: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
